import { prop, identity } from 'ramda';
import { get } from 'redux/shelf';
import { createSelector } from 'reselect';

export const getUser = createSelector(get('user', 'data'), identity);

export const getEmail = createSelector(getUser, prop('email'));

export const getName = createSelector(getUser, prop('name'));

export const getSelectedMerchantId = createSelector(
  get('user', 'merchantId'),
  identity
);
export const getSelectedMerchantOnboardingId = createSelector(
  get('user', 'onboardingId'),
  identity
);

export const hasOnlineStore2Support = createSelector(
  get('user', 'hasOnlineStore2Support'),
  identity
);

export const getShopifyThemes = createSelector(
  get('user', 'shopifyThemes'),
  (themes: Array<any>) =>
    themes
      ? themes.reduce(
          (acc, theme) => ({
            ...acc,
            [theme.id]: theme.name,
          }),
          {}
        )
      : {}
);
